import { type FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import { NavigationBar } from '@retailer-platform/shared-components/src/tds'
import useAccessControl from '../../../legacy/components/AccessControl/useAccessControl'
import { FeatureToggle } from '../../../legacy/contexts/featureToggles/FeatureToggleContext'
import { useRetailerAgentEnabled } from '../../../modules/retailer-agent/hooks/useRetailerAgentEnabled'
import { useRetailerAgentPanel } from '../../../modules/retailer-agent/RetailerAgentPageContext'

export const TdsRetailerAgentButton: FunctionComponent = () => {
  const intl = useIntl()
  const hasAccess = useAccessControl()
  const { enabled } = useRetailerAgentEnabled()
  const { isPanelOpen, setIsPanelOpen } = useRetailerAgentPanel()

  if (!hasAccess({ featureToggles: [FeatureToggle.RetailerAgent] })) return null
  if (!enabled) return null

  return (
    <NavigationBar.Button
      aria-label={intl.formatMessage({ id: 'retailerAgent.title' })}
      icon="ai"
      isActive={isPanelOpen}
      onPress={() => setIsPanelOpen(prev => !prev)}
    />
  )
}
